<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar :logo="logo">
      <template #links>
        <sidebar-item
          :link="{
            name: 'Cuentas',
            icon: 'ni ni-archive-2 text-blue',
            path: '/accounts-list',
          }"
        />

        <sidebar-item
          v-can:index="'payment_requests'"
          :link="{
            name: 'Movimientos',
            icon: 'ni ni-money-coins text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Monitor', path: '/transactions-tickets/monitor' }"
          />
          <sidebar-item
            :link="{
              name: 'Historial Transacciones',
              path: '/transactions-tickets/record',
            }"
          />
          <!-- <sidebar-item
            v-can="'index_remote_payment_requests'"
            :link="{
              name: 'Historial de no afiliados',
              path: '/transactions-tickets/affiliated',
            }"
          /> -->
          <sidebar-item
            v-can="'index_transfer_requests'"
            :link="{
              name: 'Historial Transferencias',
              path: '/transfer/history',
            }"
          />
        </sidebar-item>

        <!-- <sidebar-item
          v-can:index="'permissions'"
          :link="{
            name: 'Tickets',
            icon: 'ni ni-vector text-red',
            path: '/tickets',
          }"
        /> -->

        <!-- <sidebar-item
          v-can:index="'liquidations'"
          :link="{
            name: 'Liquidaciones',
            icon: 'ni ni-ungroup text-orange',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Transacciones a Liquidar',
              path: '/liquidations',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Transacciones Abonadas',
              path: '/transactionsPaid',
            }"
          />

          <sidebar-item
            :link="{
              name: 'Reportes',
              path: '/liquidations-report',
            }"
          />
        </sidebar-item> -->

        <!-- <sidebar-item
          :link="{
            name: $t('menu.commerce.plural.formal'),
            icon: 'ni ni-shop text-info',
          }"
        >
          <sidebar-item
            v-can="'index_companies'"
            :link="{
              name: $t('menu.company.plural.formal'),
              path: '/commerce/company',
              exact: 'true',
            }"
          />
          <sidebar-item
            v-can:index="'commerces'"
            :link="{
              name: $t('menu.commerce.plural.formal'),
              path: '/commerce/partners',
            }"
          />
          <sidebar-item
            v-can:index="'drafts_companies'"
            :link="{ name: 'Inbound', path: '/commerce/inbound' }"
          />
          <sidebar-item
            :link="{
              name: 'Categorías',
              path: '/commerce/category',
            }"
          />
        </sidebar-item> -->
        <sidebar-item
          v-can:index="'users'"
          :link="{
            name: 'Clientes',
            icon: 'ni ni-circle-08 text-pink',
            path: '/accounts',
          }"
        />

        <sidebar-item
          v-can:index="'permissions'"
          :link="{
            name: 'Permisos',
            icon: 'ni ni-key-25 text-pink',
            path: '/permisos',
          }"
        />

        <!-- <sidebar-item
          v-can:index="'banners'"
          :link="{
            name: 'Mercadeo',
            icon: 'ni ni-spaceship text-default',
          }"
        > -->
        <!-- <sidebar-item
            :link="{
              name: 'Banners',
              path: '/noveltiesAndPromotions/banners/',
            }"
          /> -->
        <!-- <sidebar-item
            :link="{
              name: 'Descuentos',
              path: '/noveltiesAndPromotions/discounts/',
            }"
          />
          <sidebar-item
            v-can:index="'cashbacks'"
            :link="{
              name: 'Cashback',
              path: '/noveltiesAndPromotions/cashback/',
            }"
          />
        </sidebar-item> -->
        <!-- <sidebar-item
          :link="{
            name: 'Retiros a cuentas bancarias',
            icon: 'ni ni-archive-2 text-pink',
            path: '/refund-by-transfer',
          }"
        /> -->
        <sidebar-item
          v-can:index="'staffs'"
          :link="{
            name: 'Gestión de staff',
            icon: 'ni ni-badge text-info',
            path: '/staff',
          }"
        />
      </template>
      <template #links-after>
        <small ref="version" class="version">Versión: {{ version }}</small>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType" />

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view />
        </fade-transition>
      </div>
      <content-footer v-if="$route.meta.hideFooter" />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import { FadeTransition } from 'vue2-transitions';
import logo from '@/assets/images/logo-white.svg';
import { mapGetters } from 'vuex';
import authTypes from '@/store/types/auth';
import { version } from '@/../package.json';
import Vue from 'vue';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default Vue.extend({
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      logo,
      version,
    };
  },
  methods: {
    initScrollbar() {
      const isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    },
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      `authModule/${authTypes.getters.AUTH_PERMISSIONS}`
      // ...
    ]),
  },
  mounted() {
    this.initScrollbar();
  },
});
</script>
<style lang="scss">
.version {
  display: block;
  margin: 0 0 0.7rem 0;
  color: gray;
  font-size: 0.7rem;
}
</style>
